// extracted by mini-css-extract-plugin
module.exports = {"movieReview":"FWBAp","img":"N9pLI","content":"JbbLe","flexbox":"gbZVY","rating":"FPU4P","isSlide":"it85y","cardSlider":"AbAg6"};